import styled from 'styled-components';
export const Spacer = styled.div `
  height: ${o => o.height}px;
  width: ${o => (o.width !== undefined ? `${o.width}px` : '100%')};
`;
//# sourceMappingURL=index.js.map